import RequestPage from "./Pages/RequestPage";
import SuccessPage from "./Pages/SuccessPage";



const AppRoutes = [
    {
        index: true,
        element: <RequestPage />
    },
    {
        path: '/success',
        element: <SuccessPage />
    },
];

export default AppRoutes;
